export default __webpack_public_path__ + "static/media/TavernNeon.62e3a187.png";